import styled from 'styled-components';
import { colors, font, breakpoints } from '@chegg-ui/theme';
var _font$size = font.size,
  px12 = _font$size.px12,
  px16 = _font$size.px16,
  px32 = _font$size.px32;
export var TermsAndConditionsContainer = styled.div.withConfig({
  componentId: "sc-ue092r-0"
})(["font-size:", ";color:", ";display:flex;flex-direction:column;width:100%;"], px16, colors.link);
export var TermsAndConditionsTextSlider = styled.div.withConfig({
  componentId: "sc-ue092r-1"
})(["@media screen and (min-width:768px) and (max-width:", "){margin-top:", ";}"], breakpoints.lg.max, px32);
export var TermsAndConditionsText = styled.div.withConfig({
  componentId: "sc-ue092r-2"
})(["", " ", " font-size:", ";line-height:", ";color:", ";text-align:left;> span{line-height:", ";}"], function (_ref) {
  var isOpen = _ref.isOpen;
  return (/* istanbul ignore next */
    isOpen && "\n  background-color: ".concat(colors.white, ";\n  max-height: 100%;\n  overflow: auto;\n  ")
  );
}, function (_ref2) {
  var isOpen = _ref2.isOpen;
  return !isOpen && "\n  ";
}, px12, font.lineHeight.sm, colors.dark, font.lineHeight.md);
export var ChevronWrapper = styled.div.withConfig({
  componentId: "sc-ue092r-3"
})(["display:flex;@media (min-width:768px){justify-content:flex-start;}"]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/modules/TermsAndConditions/styled.js
// module id = 4715
// module chunks = 11